import request from "@/service";

/* 日志列表 */
export function getSmsPage(data) {
  return request({
    url: "/user/sys/sms/page",
    method: "get",
    params: data
  });
}
